module.exports = __webpack_public_path__ + "static/media/imbattle_gif.a60abe52.gif";